export default __webpack_public_path__ + "static/media/logo.9118f5b1.png";